import React, { useState } from "react";
import { Link } from "react-router-dom";

const ButtonComp = ({
  btnText,
  link,
  img,
  className,
  btnClassName,
  disabled = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const buttonClass = btnClassName || "primary-btn";

  const defaultArrow = img
    ? img
    : "/images/web-new-images/new-dark-arrow.svg";

  const focusedArrow = "/images/web-new-images/new-green-arrow.png";

  const arrowImage = isFocused ? focusedArrow : defaultArrow;

  const commonProps = {
    className: `${buttonClass} text-center FS16FW500 fw-700 ${className || ""}`,
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    // onMouseEnter: () => setIsFocused(true),
    // onMouseLeave: () => setIsFocused(false),
  };

  // Button
  if (typeof link === "function") {
    return (
      <button
        type="button"
        onClick={link}
        disabled={disabled}
        aria-busy={disabled}
        {...commonProps}
        style={{ border: "none" }}
      >
        {btnText}{" "}
        <img src={arrowImage} alt="LA" />
      </button>
    );
  }

  const isExternal =
    link &&
    (link.startsWith("http://") ||
      link.startsWith("https://"));

  // External Link
  if (isExternal) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        {...commonProps}
      >
        {btnText}{" "}
        <img src={arrowImage} alt="LA" />
      </a>
    );
  }

  // Internal Link
  return (
    <Link
      to={link || "/auth/register"}
      {...commonProps}
    >
      {btnText}{" "}
      <img src={arrowImage} alt="LA" />
    </Link>
  );
};

export default ButtonComp;